import { ReactComponent as CheckmarkIcon } from '../../../../images/icons/CheckmarkWhite.svg';
import { useTranslation } from 'react-i18next';
import './TagCompleted.scss';

export const TagCompleted = () => {
  const { t } = useTranslation();
  return (
    <div className="completion-tag">
      <div className='completion-tag-icon'>
        <CheckmarkIcon />
      </div>
      <span className='completion-tag-text'>{t('Completed', { ns: 'learningHub' })}</span>
    </div>
  )
}
